"use client";

import type React from "react";

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  BookOpen,
  Award,
  Heart,
  Globe,
  ArrowLeft,
  Calendar,
  Clock,
  MapPin,
  Phone,
} from "lucide-react";
import { motion } from "motion/react";
import { cardVariants, container, item, slideIn } from "@/lib/framer";
import { facilities } from "@/lib/data";

export default function AboutPage() {
  // const [currentSlide, setCurrentSlide] = useState(0);
  // const [dragging, setDragging] = useState(false);
  // const [dragStart, setDragStart] = useState(0);
  // const [dragEnd, setDragEnd] = useState(0);
  // const carouselRef = useRef<HTMLDivElement>(null);

  // const carouselImages = [
  //   {
  //     src: "/placeholder.svg?height=600&width=1920",
  //     alt: "Shree Janakalyan Boarding School campus",
  //     title: "Welcome to Shree Janakalyan Boarding School",
  //     subtitle: "Nurturing young minds in Pokhara since 1995",
  //   },
  //   {
  //     src: "/placeholder.svg?height=600&width=1920",
  //     alt: "Students in classroom",
  //     title: "Quality Education",
  //     subtitle: "Providing excellence in teaching and learning",
  //   },
  //   {
  //     src: "/placeholder.svg?height=600&width=1920",
  //     alt: "School facilities",
  //     title: "Modern Facilities",
  //     subtitle: "State-of-the-art infrastructure for optimal learning",
  //   },
  //   {
  //     src: "/placeholder.svg?height=600&width=1920",
  //     alt: "Cultural activities",
  //     title: "Cultural Heritage",
  //     subtitle: "Preserving Nepali traditions and values",
  //   },
  // ];

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCounts((prev) => ({
  //       years: prev.years < 28 ? prev.years + 1 : 28,
  //       students: prev.students < 450 ? prev.students + 15 : 450,
  //       teachers: prev.teachers < 35 ? prev.teachers + 1 : 35,
  //       awards: prev.awards < 12 ? prev.awards + 1 : 12,
  //     }));
  //   }, 100);

  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (!dragging) {
  //       setCurrentSlide((prev) =>
  //         prev === carouselImages.length - 1 ? 0 : prev + 1
  //       );
  //     }
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, [dragging, carouselImages.length]);

  // const handleDragStart = (e: React.MouseEvent | React.TouchEvent) => {
  //   setDragging(true);
  //   if ("touches" in e) {
  //     setDragStart(e.touches[0].clientX);
  //   } else {
  //     setDragStart(e.clientX);
  //   }
  // };

  // const handleDragMove = (e: React.MouseEvent | React.TouchEvent) => {
  //   if (!dragging) return;
  //   if ("touches" in e) {
  //     setDragEnd(e.touches[0].clientX);
  //   } else {
  //     setDragEnd(e.clientX);
  //   }
  // };

  // const handleDragEnd = () => {
  //   setDragging(false);
  //   if (dragStart - dragEnd > 100) {
  //     // Swiped left
  //     setCurrentSlide((prev) =>
  //       prev === carouselImages.length - 1 ? 0 : prev + 1
  //     );
  //   } else if (dragStart - dragEnd < -100) {
  //     // Swiped right
  //     setCurrentSlide((prev) =>
  //       prev === 0 ? carouselImages.length - 1 : prev - 1
  //     );
  //   }
  // };

  // const nextSlide = () => {
  //   setCurrentSlide((prev) =>
  //     prev === carouselImages.length - 1 ? 0 : prev + 1
  //   );
  // };

  // const prevSlide = () => {
  //   setCurrentSlide((prev) =>
  //     prev === 0 ? carouselImages.length - 1 : prev - 1
  //   );
  // };

  // const timelineEvents = [
  //   {
  //     year: "1995",
  //     title: "Foundation",
  //     description:
  //       "Shree Janakalyan Boarding School was established with just 2 classrooms and 25 students.",
  //   },
  //   {
  //     year: "2000",
  //     title: "First Expansion",
  //     description:
  //       "Added a new building with 6 more classrooms and a small library.",
  //   },
  //   {
  //     year: "2005",
  //     title: "Curriculum Enhancement",
  //     description:
  //       "Introduced comprehensive English medium curriculum and cultural programs.",
  //   },
  //   {
  //     year: "2010",
  //     title: "Technology Integration",
  //     description:
  //       "Established our first computer lab with 15 computers for students.",
  //   },
  //   {
  //     year: "2015",
  //     title: "Campus Modernization",
  //     description:
  //       "Renovated all facilities and added a science lab and art studio.",
  //   },
  //   {
  //     year: "2020",
  //     title: "Excellence Recognition",
  //     description:
  //       "Received National Award for Educational Excellence in Primary Education.",
  //   },
  //   {
  //     year: "2023",
  //     title: "Digital Transformation",
  //     description:
  //       "Implemented digital learning tools and interactive smart classrooms.",
  //   },
  // ];

  const coreValues = [
    {
      icon: <BookOpen className="h-8 w-8 text-primary" />,
      title: "Academic Excellence",
      description:
        "We strive for the highest standards of education and learning outcomes.",
    },
    {
      icon: <Heart className="h-8 w-8 text-primary" />,
      title: "Compassion",
      description:
        "We nurture empathy and kindness in our students and community.",
    },
    {
      icon: <Globe className="h-8 w-8 text-primary" />,
      title: "Global Perspective",
      description: "We prepare students to be responsible global citizens.",
    },
    {
      icon: <Award className="h-8 w-8 text-primary" />,
      title: "Integrity",
      description: "We uphold honesty, ethics, and moral values in all we do.",
    },
  ];

  const leadershipTeam = [
    {
      name: "Krishna Prasad Dahal",
      role: "Principal",
      image:
        "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742043988/princpal_fjkkwm.jpg",
      bio: "With over two decades of experience in the education sector, it has been an incredible journey to witness the growth of this institution. As the Principal, I am deeply committed to fostering an environment that values both academic excellence and personal development. We aim to equip our students not only with knowledge but also with the skills and values that will shape them into responsible, compassionate, and well-rounded individuals. Our dedicated faculty and staff work tirelessly to ensure that each student is provided with the tools they need to succeed, both inside and outside the classroom. At our school, every student’s success is our success, and we pride ourselves on being a part of their journey",
    },
    {
      name: "Bishnu Prasad Dahal",
      role: "Founder",
      image:
        "https://res.cloudinary.com/ds1npuv1v/image/upload/v1742043814/founder_qusam7.jpg",
      bio: "The founding of this institution in 1995 was driven by a vision: to create a place where students can not only receive a top-tier education but also grow as leaders of tomorrow. Over the years, it has been immensely rewarding to see our students achieve their goals, contribute to society, and become agents of change. As the Founder, my passion for education remains unwavering, and it is my belief that every child has the potential to achieve greatness. This institution has always been about much more than academics; it's about nurturing the potential within each student and empowering them to realize their dreams. We continue to build on this foundation, with a strong focus on holistic education that prepares students for the challenges and opportunities of the future.",
    },
    // {
    //   name: "Rajendra Thapa",
    //   role: "Administrative Director",
    //   image: "/placeholder.svg?height=200&width=200",
    //   bio: "Mr. Thapa manages school operations and community relations.",
    // },
  ];

  return (
    <div className="flex min-h-screen flex-col">
      {/* Back to Home Link */}
      <div className="container mx-auto px-4 py-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Link
            href="/"
            className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Link>
        </motion.div>
      </div>

      {/* Introduction */}
      <section className="py-8 md:py-10">
        <div className="container mx-auto px-4">
          <div className="grid gap-12 md:grid-cols-2 lg:gap-16 items-center">
            <motion.div
              className="space-y-6"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.3 }}
              variants={slideIn}
            >
              <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
                Our Story
              </h2>
              <p className="text-muted-foreground">
                Shree Janakalyan Boarding School was founded in 2052 BS with a
                vision to provide quality education to children in Pokhara. What
                started as a small school with just two classrooms and 25
                students has now grown into one of the most respected
                educational institutions in the region.
              </p>
              <p className="text-muted-foreground">
                Our journey has been guided by our commitment to academic
                excellence, cultural values, and holistic development. Over the
                years, we have continuously evolved our teaching methodologies
                and campus facilities to provide the best learning environment
                for our students.
              </p>
              <p className="text-muted-foreground">
                Today, we are proud to serve over 200 students with a team of 15
                dedicated educators. Our alumni have gone on to excel in various
                fields, carrying forward the values and knowledge they gained at
                Shree Janakalyan Boarding School.
              </p>
            </motion.div>
            <motion.div
              className="relative h-[400px] overflow-hidden rounded-lg"
              initial={{ opacity: 0, x: 100 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <Image
                src="https://res.cloudinary.com/ds1npuv1v/image/upload/v1742043169/aboutus_pt3csl.jpg"
                alt="School history"
                fill
                className="object-cover"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      <section className="bg-muted py-16">
        <div className="container mx-auto px-4">
          <motion.div
            className="grid grid-cols-2 md:grid-cols-4 gap-8"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.div className="text-center" variants={item}>
              <div className="text-4xl font-bold text-primary mb-2">29+</div>
              <div className="text-sm text-muted-foreground">
                Years of Excellence
              </div>
            </motion.div>
            <motion.div className="text-center" variants={item}>
              <div className="text-4xl font-bold text-primary mb-2">210+</div>
              <div className="text-sm text-muted-foreground">
                Happy Students
              </div>
            </motion.div>
            <motion.div className="text-center" variants={item}>
              <div className="text-4xl font-bold text-primary mb-2">16+</div>
              <div className="text-sm text-muted-foreground">
                Dedicated Teachers
              </div>
            </motion.div>
            <motion.div className="text-center" variants={item}>
              <div className="text-4xl font-bold text-primary mb-2">48+</div>
              <div className="text-sm text-muted-foreground">
                Awards Received
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Mission and Vision */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            className="mb-12 text-center"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.h2
              className="text-3xl font-bold tracking-tight sm:text-4xl mb-4"
              variants={item}
            >
              Our Mission & Vision
            </motion.h2>
            <motion.div className="mx-auto max-w-3xl" variants={item}>
              <p className="text-muted-foreground">
                Guiding principles that shape our educational approach and
                community
              </p>
            </motion.div>
          </motion.div>

          <div className="grid gap-8 md:grid-cols-2">
            <motion.div
              className="bg-primary/5 p-8 rounded-lg"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{
                y: -5,
                boxShadow:
                  "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              }}
            >
              <h3 className="text-2xl font-bold mb-4 flex items-center">
                <BookOpen className="mr-2 h-6 w-6 text-primary" />
                Our Mission
              </h3>
              <p className="text-muted-foreground mb-4">
                At Shree Janakalyan Boarding School, we are dedicated to
                providing a nurturing and stimulating environment where children
                can develop a love for learning. Our mission is to empower
                students with knowledge, skills, and values that will help them
                become responsible global citizens.
              </p>
              <p className="text-muted-foreground">
                We strive to create an inclusive community where diversity is
                celebrated, creativity is encouraged, and each child&apos;s
                unique potential is recognized and nurtured.
              </p>
            </motion.div>

            <motion.div
              className="bg-primary/5 p-8 rounded-lg"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              whileHover={{
                y: -5,
                boxShadow:
                  "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              }}
            >
              <h3 className="text-2xl font-bold mb-4 flex items-center">
                <Globe className="mr-2 h-6 w-6 text-primary" />
                Our Vision
              </h3>
              <p className="text-muted-foreground mb-4">
                To be a leading educational institution in Pokhara that fosters
                academic excellence, cultural awareness, and personal growth in
                every child.
              </p>
              <p className="text-muted-foreground">
                We envision our students as future leaders who will contribute
                positively to society, uphold ethical values, and drive positive
                change in their communities and beyond. Through innovative
                teaching practices and a holistic approach to education, we aim
                to prepare students for the challenges and opportunities of the
                21st century.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="bg-muted py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            className="mb-12 text-center"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.h2
              className="text-3xl font-bold tracking-tight sm:text-4xl mb-4"
              variants={item}
            >
              Our Core Values
            </motion.h2>
            <motion.div className="mx-auto max-w-3xl" variants={item}>
              <p className="text-muted-foreground">
                The principles that guide our educational philosophy and
                community
              </p>
            </motion.div>
          </motion.div>

          <motion.div
            className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={container}
          >
            {coreValues.map((value, index) => (
              <motion.div key={index} variants={item}>
                <motion.div
                  whileHover={{
                    y: -10,
                    boxShadow:
                      "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <Card>
                    <CardContent className="flex flex-col items-center p-6 text-center">
                      <motion.div
                        className="mb-4 rounded-full bg-primary/10 p-4"
                        whileHover={{ rotate: 5, scale: 1.1 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 10,
                        }}
                      >
                        {value.icon}
                      </motion.div>
                      <h3 className="mb-2 text-xl font-bold">{value.title}</h3>
                      <p className="text-sm text-muted-foreground">
                        {value.description}
                      </p>
                    </CardContent>
                  </Card>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Timeline */}
      {/* <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            className="mb-12 text-center"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.h2
              className="text-3xl font-bold tracking-tight sm:text-4xl mb-4"
              variants={item}
            >
              Our Journey
            </motion.h2>
            <motion.div className="mx-auto max-w-3xl" variants={item}>
              <p className="text-muted-foreground">
                Key milestones in the history of Shree Janakalyan Boarding
                School
              </p>
            </motion.div>
          </motion.div>

          <div className="relative border-l border-primary/30 ml-4 md:ml-0 md:mx-auto md:max-w-3xl pl-8 md:pl-0">
            {timelineEvents.map((event, index) => (
              <motion.div
                key={index}
                className={`
mb - 12
md: grid
md: grid - cols - 2
md: gap - 8
md: items - center
$
{
  index % 2 === 0 ? "md:text-right" : ""
}
;`}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div
                  className={`
$
{
  index % 2 === 0 ? "md:order-1" : "md:order-2"
}
;`}
                >
                  <div className="absolute left-0 md:left-1/2 transform -translate-x-4 md:-translate-x-4 mt-1">
                    <motion.div
                      className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-xs"
                      whileHover={{ scale: 1.2 }}
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 10,
                      }}
                    >
                      {event.year.slice(2)}
                    </motion.div>
                  </div>
                  <h3 className="text-xl font-bold">
                    {event.year}: {event.title}
                  </h3>
                  <p className="text-muted-foreground mt-2">
                    {event.description}
                  </p>
                </div>
                <div
                  className={`
hidden
md: block
$
{
  index % 2 === 0 ? "md:order-2" : "md:order-1"
}
`}
                ></div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Leadership Team */}
      <section className="bg-muted py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            className="mb-12 text-center"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.h2
              className="text-3xl font-bold tracking-tight sm:text-4xl mb-4"
              variants={item}
            >
              Our Leadership Team
            </motion.h2>
            <motion.div className="mx-auto max-w-3xl" variants={item}>
              <p className="text-muted-foreground">
                Meet the dedicated professionals guiding our school
              </p>
            </motion.div>
          </motion.div>

          <motion.div
            className="grid gap-8 md:grid-cols-2"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            variants={container}
          >
            {leadershipTeam.map((leader, index) => (
              <motion.div key={index} variants={item}>
                <motion.div
                  whileHover={{
                    y: -10,
                    boxShadow:
                      "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                  }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  <Card>
                    <div className="relative h-96 md:h-[600px] -mt-6 overflow-hidden rounded-t-lg">
                      <Image
                        src={leader.image || "/placeholder.svg"}
                        alt={leader.name}
                        fill
                        className="object-cover transition-transform duration-300 group-hover:scale-105"
                      />
                    </div>
                    <CardContent className="p-6">
                      <h3 className="text-xl font-bold">{leader.name}</h3>
                      <p className="text-sm text-primary font-medium mb-4">
                        {leader.role}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {leader.bio}
                      </p>
                    </CardContent>
                  </Card>
                </motion.div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Facilities */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            className="mb-12 text-center"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={container}
          >
            <motion.h2
              className="text-3xl font-bold tracking-tight sm:text-4xl mb-4"
              variants={item}
            >
              Our Facilities
            </motion.h2>
            <motion.div className="mx-auto max-w-3xl" variants={item}>
              <p className="text-muted-foreground">
                Modern amenities that enhance the learning experience
              </p>
            </motion.div>
          </motion.div>

          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {facilities.map((facility, index) => {
              const Icon = facility.icon;
              return (
                <motion.div
                  key={index}
                  variants={cardVariants}
                  initial="hidden"
                  animate="visible"
                  whileHover="hover"
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <div className="bg-card rounded-lg overflow-hidden shadow-md p-6 text-center">
                    <div className="flex justify-center mb-4">
                      <Icon className="h-12 w-12 text-primary" />
                    </div>
                    <h3 className="text-xl font-bold mb-2">{facility.title}</h3>
                    <p className="text-sm text-muted-foreground">
                      {facility.desc}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-primary text-primary-foreground py-12">
        <div className="container mx-auto px-4">
          <div className="grid gap-8 md:grid-cols-2 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold mb-4">Visit Our School</h2>
              <p className="mb-6">
                We invite you to visit our campus and experience the vibrant
                learning environment at Shree Janakalyan Boarding School.
                Schedule a tour to meet our teachers, see our facilities, and
                learn more about our programs.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <MapPin className="mt-1 h-5 w-5" />
                  <div>
                    <h3 className="font-semibold">Address</h3>
                    <p>Pokhara-23, Kaski, Nepal</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Clock className="mt-1 h-5 w-5" />
                  <div>
                    <h3 className="font-semibold">Visiting Hours</h3>
                    <p>Sunday to Friday: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <Calendar className="mt-1 h-5 w-5" />
                  <div>
                    <h3 className="font-semibold">School Year</h3>
                    <p>
                      Baishakh to Chaitra, with breaks align with Nepali
                      festivals
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex flex-col gap-4 justify-center"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link href={"/contact"}>
                  <Button
                    size="lg"
                    variant="secondary"
                    className="w-full md:w-auto cursor-pointer"
                  >
                    <Calendar className="mr-2 h-5 w-5" />
                    Schedule a Visit
                  </Button>
                </Link>
              </motion.div>
              {/* <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  size="lg"
                  variant="secondary"
                  className="w-full md:w-auto cursor-pointer"
                >
                  <Calendar className="mr-2 h-5 w-5" />
                  Schedule a Visit
                </Button>
              </motion.div>
              {/* <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  size="lg"
                  variant="secondary"
                  className="w-full md:w-auto cursor-pointer"
                >
                  Download School Brochure
                </Button>
              </motion.div> */}
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link href={"/contact"}>
                  <Button
                    size="lg"
                    variant="secondary"
                    className="w-full md:w-auto cursor-pointer"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Contact Admissions
                  </Button>
                </Link>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
